exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".date-title[data-v-540c886d] {\n  font-weight: 500;\n  font-size: 1.75rem;\n  color: rgba(6, 38, 62, 0.74);\n}\n.name-title[data-v-540c886d] {\n  font-size: 14px;\n  font-weight: 500;\n  color: #06263e;\n}\n.title-ts-detail[data-v-540c886d] {\n  border-bottom: 0.005rem solid rgba(226, 230, 235, 0.85);\n  margin-left: -12px;\n  margin-right: -12px;\n}\n.border-encoded[data-v-540c886d] {\n  border: 2px solid #cad0d7;\n  border-radius: 5px;\n}\n.card > > > table > tbody > tr > td[data-v-540c886d] {\n  cursor: pointer;\n}\n", ""]);

// exports
